module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTE1Mi4zIDUwNi45YTMxLjkgMzEuOSAwIDAgMSA5LjMtMjAuN2wyNzEuNi0yNzEuNWEzMiAzMiAwIDAgMSA0NS4yIDQ1LjJMMjU4LjIgNDgwIDgzMiA0ODBhMzIgMzIgMCAwIDEgMCA2NEgyNjMuOGwyMTQuNiAyMTQuNmEzMiAzMiAwIDEgMS00NS4yIDQ1LjJMMTYxLjYgNTMyLjNhMzEuOSAzMS45IDAgMCAxLTkuMy0yMC43di00Ljd6IiBmaWxsPSIjMCIgcC1pZD0iODg0Ij48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Arrow-left-outlined.svg
// module id = sCy+
// module chunks = 73